import { combineReducers } from 'redux'

// ACTIONS
export const SAVE = 'company/candidateList/infiniteScroll/SAVE'
export const RESET = 'company/candidateList/infiniteScroll/RESET'

// ACTION CREATORS
export const save = position => ({
  type: SAVE,
  payload: { position },
})

export const reset = () => ({
  type: RESET,
})

// REDUCERS
const defaultScroll = {
  position: 0,
}

const scroll = (state = defaultScroll, { type, payload }) => {
  switch (type) {
    case SAVE:
      return {
        ...state,
        ...payload,
      }

    case RESET:
      return defaultScroll

    default:
      return state
  }
}

export default combineReducers({
  scroll,
})
